// Author : Vishnu
//Version :0.0.1
// MODIFIED DATE: 18/08/2025
const ChangeMeetingDateActionTypes = {
	/***************   Start Update Branch Meeting Date ******************/
	UPDATE_BRANCH_MEETING_DATE_START: 'update_branch_meeting_date_start',
	UPDATE_BRANCH_MEETING_DATE_SUCCESS: 'update_branch_meeting_date_success',
	UPDATE_BRANCH_MEETING_DATE_FAILURE: 'update_branch_meeting_date_failure',
	UPDATE_BRANCH_MEETING_DATE_RESPONSE_RESET: 'update_branch_meeting_date_response_reset',
	UPDATE_BRANCH_MEETING_DATE_RESPONSE_CHANGED: 'update_branch_meeting_date_response_changed',
	/***************   End Update Branch Meeting Date ******************/

	/***************   Start Update Branch Meeting Date Auto Loan ******************/
	UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_START: 'update_branch_meeting_date_auto_loan_start',
	UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_SUCCESS: 'update_branch_meeting_date_auto_loan_success',
	UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_FAILURE: 'update_branch_meeting_date_auto_loan_failure',
	UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_RESPONSE_RESET:
		'update_branch_meeting_date_auto_loan_response_reset',
	UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_RESPONSE_CHANGED:
		'update_branch_meeting_date_auto_loan_response_changed',
	/***************   End Update Branch Meeting Date Auto Loan ******************/

	/***************   Get Branch Meeting Date Details Start ******************/
	GET_BRANCH_MEETING_DATE_DETAILS_START: 'get_branch_meeting_date_details_start',
	GET_BRANCH_MEETING_DATE_DETAILS_SUCCESS: 'get_branch_meeting_date_details_success',
	GET_BRANCH_MEETING_DATE_DETAILS_FAILURE: 'get_branch_meeting_date_details_failure',
	GET_BRANCH_MEETING_DATE_DETAILS_RESPONSE_RESET:
		'get_branch_meeting_date_details_response_reset',
	GET_BRANCH_MEETING_DATE_DETAILS_RESPONSE_CHANGED:
		'get_branch_meeting_date_details_response_changed',
	/***************   Get Branch Meeting Date Details End ******************/

	/***************   Get Branch Meeting Date Details Auto Loan Start ******************/
	GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_START:
		'get_branch_meeting_date_details_auto_loan_start',
	GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_SUCCESS:
		'get_branch_meeting_date_details_auto_loan_success',
	GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_FAILURE:
		'get_branch_meeting_date_details_auto_loan_failure',
	GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_RESPONSE_RESET:
		'get_branch_meeting_date_details_auto_loan_response_reset',
	GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_RESPONSE_CHANGED:
		'get_branch_meeting_date_details_auto_loan_response_changed',
	/***************   Get Branch Meeting Date Details Auto Loan End ******************/

	/***************  Get Loan Center Group Details Start ******************/
	GET_LOAN_CENTER_GROUP_DETAILS_START: 'get_loan_center_group_details_start',
	GET_LOAN_CENTER_GROUP_DETAILS_SUCCESS: 'get_loan_center_group_details_success',
	GET_LOAN_CENTER_GROUP_DETAILS_FAILURE: 'get_loan_center_group_details_failure',
	GET_LOAN_CENTER_GROUP_DETAILS_RESPONSE_RESET: 'get_loan_center_group_details_response_reset',
	GET_LOAN_CENTER_GROUP_DETAILS_RESPONSE_CHANGED:
		'get_loan_center_group_details_response_changed',
	/***************  Get Loan Center Group Details End ******************/

	/***************  Get Loan Center Group Details Auto Loan Start ******************/
	GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_START: 'get_loan_center_group_details_auto_loan_start',
	GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_SUCCESS:
		'get_loan_center_group_details_auto_loan_success',
	GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_FAILURE:
		'get_loan_center_group_details_auto_loan_failure',
	GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_RESPONSE_RESET:
		'get_loan_center_group_details_auto_loan_response_reset',
	GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_RESPONSE_CHANGED:
		'get_loan_center_group_details_auto_loan_response_changed',
	/***************  Get Loan Center Group Details Auto Loan End ******************/

	/***************  Get Loan Index Details Based On Center Group Start ******************/
	GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_START:
		'get_particular_loan_center_group_details_start',
	GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_SUCCESS:
		'get_particular_loan_center_group_details_success',
	GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_FAILURE:
		'get_particular_loan_center_group_details_failure',
	GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_RESPONSE_RESET:
		'get_particular_loan_center_group_details_response_reset',
	GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_RESPONSE_CHANGED:
		'get_particular_loan_center_group_details_response_changed',
	/***************  Get Loan Index Details Based On Center Group End ******************/

	/***************  Get Loan Index Details Based On Center Group Auto Loan Start ******************/
	GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_START:
		'get_particular_loan_center_group_details_auto_loan_start',
	GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_SUCCESS:
		'get_particular_loan_center_group_details_auto_loan_success',
	GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_FAILURE:
		'get_particular_loan_center_group_details_auto_loan_failure',
	GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_RESPONSE_RESET:
		'get_particular_loan_center_group_details_auto_loan_response_reset',
	GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_RESPONSE_CHANGED:
		'get_particular_loan_center_group_details_auto_loan_response_changed',
	/***************  Get Loan Index Details Based On Center Group Auto Loan End ******************/

	/***************   Start Update Branch New Meeting Date ******************/
	UPDATE_SINGLE_BRANCH_MEETING_DATE_START: 'update_single_branch_meeting_date_start',
	UPDATE_SINGLE_BRANCH_MEETING_DATE_SUCCESS: 'update_single_branch_meeting_date_success',
	UPDATE_SINGLE_BRANCH_MEETING_DATE_FAILURE: 'update_single_branch_meeting_date_failure',
	UPDATE_SINGLE_BRANCH_MEETING_DATE_RESPONSE_RESET:
		'update_single_branch_meeting_date_response_reset',
	UPDATE_SINGLE_BRANCH_MEETING_DATE_RESPONSE_CHANGED:
		'update_single_branch_meeting_date_response_changed',
	/***************   End Update Branch New Meeting Date ******************/

	/***************   Start Update Branch New Meeting Date Auto Loan ******************/
	UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_START:
		'update_single_branch_meeting_date_auto_loan_start',
	UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_SUCCESS:
		'update_single_branch_meeting_date_auto_loan_success',
	UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_FAILURE:
		'update_single_branch_meeting_date_auto_loan_failure',
	UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_RESPONSE_RESET:
		'update_single_branch_meeting_date_auto_loan_response_reset',
	UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_RESPONSE_CHANGED:
		'update_single_branch_meeting_date_auto_loan_response_changed',
	/***************   End Update Branch New Meeting Date Auto Loan ******************/

	/***************  Update Loan Index Meeting Date Time Start ******************/
	UPDATE_SINGLE_CENTER_MEETING_DATE_START: 'update_single_center_meeting_date_start',
	UPDATE_SINGLE_CENTER_MEETING_DATE_SUCCESS: 'update_single_center_meeting_date_success',
	UPDATE_SINGLE_CENTER_MEETING_DATE_FAILURE: 'update_single_center_meeting_date_failure',
	UPDATE_SINGLE_CENTER_MEETING_DATE_RESPONSE_RESET:
		'update_single_center_meeting_date_response_reset',
	UPDATE_SINGLE_CENTER_MEETING_DATE_RESPONSE_CHANGED:
		'update_single_center_meeting_date_response_changed',
	/***************  Update Loan Index Meeting Date Time End ******************/

	/***************  Update Loan Index Meeting Date Time Auto Loan Start ******************/
	UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_START:
		'update_single_center_meeting_date_auto_loan_start',
	UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_SUCCESS:
		'update_single_center_meeting_date_auto_loan_success',
	UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_FAILURE:
		'update_single_center_meeting_date_auto_loan_failure',
	UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_RESPONSE_RESET:
		'update_single_center_meeting_date_auto_loan_response_reset',
	UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_RESPONSE_CHANGED:
		'update_single_center_meeting_date_auto_loan_response_changed',
	/***************  Update Loan Index Meeting Date Time Auto Loan End ******************/

	/***************  Update Loan Index Meeting Date Time Member Wise Start ******************/
	UPDATE_SINGLE_MEMBER_MEETING_DATE_START: 'update_single_member_meeting_date_start',
	UPDATE_SINGLE_MEMBER_MEETING_DATE_SUCCESS: 'update_single_member_meeting_date_success',
	UPDATE_SINGLE_MEMBER_MEETING_DATE_FAILURE: 'update_single_member_meeting_date_failure',
	UPDATE_SINGLE_MEMBER_MEETING_DATE_RESPONSE_RESET:
		'update_single_member_meeting_date_response_reset',
	UPDATE_SINGLE_MEMBER_MEETING_DATE_RESPONSE_CHANGED:
		'update_single_member_meeting_date_response_changed',
	/***************  Update Loan Index Meeting Date Time Member Wise End ******************/

	/***************  Update Loan Index Meeting Date Time Member Wise Auto Loan Start ******************/
	UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_START:
		'update_single_member_meeting_date_auto_loan_start',
	UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_SUCCESS:
		'update_single_member_meeting_date_auto_loan_success',
	UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_FAILURE:
		'update_single_member_meeting_date_auto_loan_failure',
	UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_RESPONSE_RESET:
		'update_single_member_meeting_date_auto_loan_response_reset',
	UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_RESPONSE_CHANGED:
		'update_single_member_meeting_date_auto_loan_response_changed',
	/***************  Update Loan Index Meeting Date Time Member Wise Auto Loan End ******************/
};
export default ChangeMeetingDateActionTypes;
